const about = {
    title: 'À Propos',
    header: 'À propos',
    description:
        'Bonjour, je suis charbz, un développeur web et UI/ UX de Montréal. Je conçois, developpe et assiste mes clients dans le lancement de leurs sites web.',
}

export default about
